<template>
  <div class="container">
    <input
      :checked="status == 1"
      :disabled="isNotTheTime"
      type="checkbox"
      name="button"
      id="button"
      @click="handleClick"
    />
    <label class="bevel" for="button">睡了</label>
    <span>{{ name }} 睡了沒</span>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  props: {
    name: String,
    status: Number
  },
  name: "FancyButton",
  methods: {
    checkTime() {
      return dayjs().hour() === 0 || dayjs().hour() > 21;
    },
    handleClick(e) {
      if (!this.checkTime()) {
        e.preventDefault();
        this.$toasted.error("這時間不對吧");
        setTimeout(() => {
          this.$toasted.error("還想馬扁Ｒ");
        }, 1000);
      } else {
        this.$emit("updateStatus", e.target.checked);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$red: #f33;
$red2: desaturate(darken($red, 15%), 18%);
$buttonHeight: 80;

.container {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  white-space: nowrap;
  user-select: none;
}
input {
  display: none;
}
label {
  cursor: pointer;
}
.bevel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 #{$buttonHeight/2 + 5 + "px"};
  // ^ 5px buffer between triangles and text
  height: #{$buttonHeight + "px"};
  background: $red linear-gradient(to bottom, $red 50%, $red2 50%);
  border-radius: 0px;
  box-shadow: 0px 15px 25px -10px rgba(#000, 0.5),
    inset 0px 0px 0px 0px rgba($red, 0), inset 0px -27px 0px 0px $red2;
  font-size: 20px;
  text-align: center;
  text-shadow: 0px 3px 5px $red2, 0px 5px 10px $red2, 0px 5px 10px $red2,
    0px 5px 10px $red2, 0px 5px 10px $red2;
  color: #fff;
  letter-spacing: 0.4px;
  overflow: hidden;
  outline: 0 !important;
  transform: scale(1.01);
  transition: all 0.2s ease-in-out;
  &:before,
  &:after {
    content: " ";
    width: #{$buttonHeight/2 + "px"};
    max-width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    transition: all 0.135s ease-in-out;
    transition: all 0.135s cubic-bezier(0.74, 0.16, 0.24, 0.92);
    transition-delay: 0.15s;
  }
  &:before {
    left: 0;
    background: linear-gradient(
        45deg,
        transparent calc(200% / 3),
        rgba($red, 1) calc(200% / 3)
      ),
      linear-gradient(
        -45deg,
        rgba($red2, 1) calc(100% / 3),
        transparent calc(100% / 3)
      ),
      linear-gradient(to right, $red, $red2);
  }
  &:after {
    right: 0;
    background: linear-gradient(
        -45deg,
        transparent calc(200% / 3),
        rgba($red, 1) calc(200% / 3)
      ),
      linear-gradient(
        45deg,
        rgba($red2, 1) calc(100% / 3),
        transparent calc(100% / 3)
      ),
      linear-gradient(to left, $red, $red2);
  }
  &:hover {
    transform: scale(1.07);
    box-shadow: 0px 25px 40px -5px rgba(#000, 0.3),
      inset 0px 0px 0px 0px rgba($red, 0), inset 0px -27px 0px 0px $red2;
  }
  input:checked ~ & {
    padding: 0 #{$buttonHeight/4 + 5 + "px"};
    background: rgba($red, 0);
    box-shadow: 0px 5px 15px -5px rgba(#000, 0.3), inset 0px 0px 0px 4px $red,
      inset 0px 0px 0px 0px $red2;
    border-radius: 10px;
    font-size: 24px;
    font-weight: 700;
    text-shadow: 0px 3px 5px rgba($red2, 0), 0px 5px 10px rgba($red2, 0),
      0px 5px 10px rgba($red2, 0), 0px 5px 10px rgba($red2, 0),
      0px 5px 10px rgba($red2, 0);
    color: $red;
    transform: scale(0.7) rotate(-6deg);
    transition: all 0.25s ease-in-out, text-shadow 0s ease-in-out,
      box-shadow 0.25s ease-in-out;
    transition: all 0.45s cubic-bezier(0.6, -0.9, 0.39, 1.65),
      text-shadow 0s ease-in-out,
      box-shadow 0.45s cubic-bezier(0.6, -0.9, 0.39, 1.65);
    transition-delay: 0.135s;
    &:before,
    &:after {
      transition-delay: 0s;
    }
    &:before {
      transform: translateX(-100%);
    }
    &:after {
      transform: translateX(100%);
    }
    + span {
      // opacity: 0.15;
      color: rgba($red, 0.1875);
      transform: translateY(56px);
    }
  }
}
span {
  display: block;
  margin-bottom: 10px;
  font-size: 32px;
  font-weight: 700;
  color: #d4d4d4;
  z-index: -1;
  transition: all 0.25s ease-in-out;
  transition: all 0.45s cubic-bezier(0.74, 0.16, 0.24, 0.92);
  transition-delay: 0.135s;
}
</style>
